<!-- TableComponent.vue -->
<template>
    <table :class="getTableClasses" style="width:100%">
        <thead>
        <tr>
            <th>#</th>
            <th>Job Name(Code)</th>
            <th>Dept Name (Code)</th>
            <th>Component Name</th>
            <th>Job Type name</th>
            <th>Counter Type</th>
            <th>Prev Maintenance Date</th>
            <th>Next Maintenance Due Date</th>
            <th>Assigned By</th>
            <th>Status</th>
            <th v-if="!isPrinting">Instruction Manual</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(job, index) in jobs" :key="job.id">
            <td>
                {{ (currentPage - 1) * perPage + index + 1 }}
            </td>
            <td>{{ job?.name }} ({{job?.code}})</td>
            <td>{{ job?.department?.name }} ({{job?.department?.code}})</td>
            <td>{{ job?.main_component?.name }} >>
                {{job?.component?.name}}
                <span v-if="job?.sub_component != null"> >> {{job?.sub_component?.name}}</span>
                <span v-if="job?.sub_sub_component != null">>> {{job?.sub_sub_component?.name}} </span>
            </td>
            <td>{{job?.job_type?.name}}</td>
            <td>{{ job?.counter_type }}</td>
            <td>{{job?.latestJobSchedule?.start_date | moment('DD-MM-YYYY') }}</td>
            <td>{{job?.latestJobSchedule?.end_date | moment('DD-MM-YYYY') }}</td>
            <td>{{ job?.rank_fixed_role?.name }}</td>
            <td>{{ job?.status }}</td>
            <td v-if="!isPrinting">
                <a style="text-decoration: underline;color: #0a6aa1" target="_blank" v-if="job &&  job?.instruction_manual != null" :href="job &&  job?.instruction_manual">View </a>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    import permissionsMixin from "@/mixin/permissionsMixin";
    import auth from "@/auth";

    export default {
        mixins: [permissionsMixin],
        data() {
            return {
                permissions: auth.getPermissionData(),
            }
        },
        props: {
            jobs: {
                required: true
            },
            currentPage: {
                type: Number,
                default: 1
            },
            perPage: {
                type: Number,
                default: 20
            },
            user_type: {
                required: false
            },
            isPrinting: {
                type: Boolean,
                default: false
            },
            show: {
                type: Function,
                required: false
            },
            edit: {
                type: Function,
                required: false
            },
            approvedJob: {
                type: Function,
                required: false
            },
            runningHourUpdate: {
                type: Function,
                required: false
            },
            showQRCode: {
                type: Function,
                required: false
            },
            copyComponent: {
                type: Function,
                required: false
            },
            destroy: {
                type: Function,
                required: false
            },

        },
        computed: {
            getTableClasses() {
                return {
                    'table': true,
                    'text-center': true,
                    'table-striped': !this.isPrinting,
                    'table-bordered': !this.isPrinting,
                    'table-sm': !this.isPrinting,
                    'print-table': this.isPrinting,
                    'vertical-align-middle': true
                };
            }
        }
    };
</script>

<style scoped>
    .print-table {
        /* Define styles for printing if needed */
    }
</style>
